import { roles } from "src/app/Enums/roles";

export class AddUserModel 
{
    FirstName: string;
    LastName: string;
    Email: string;
    Password: string;
    PhoneNumber: string;
    UserType: string;
}
export class UpdateUserModel 
{
    Id: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Password: string;
    PhoneNumber: string;
    UserType: string;
    UserName: string;
    IsActive: string;
    IsVerified: string;
}
export class UserDataResponseModel{
    id: string;
    firstName:string;
    lastName: string;
    email: string;
    phoneNumber: string;
    userType: string;
    isActive: string;
    isVerified: string;
}
